<template>
  <div :class="!image ? 'preview no-image' : 'preview'" :style="previewStyles">
    <img v-if="image" class="preview-image" :src="image" alt :style="previewImageStyles">
    <span v-if="!image" :style="previewImageStyles">{{ noImageMsg }}</span>
    <img class="overlay-image" :src="overlay" alt>
  </div>
</template>

<script>
export default {
  name: 'preview-screen',
  props: {
    image: String,
    imageWidth: Number,
    imageHeight: Number,
    imageOffsetTop: Number,
    imageOffsetLeft: Number,
    overlay: String,
    overlayWidth: Number,
    overlayHeight: Number,
    noImageMsg: {
      type: String,
      default: 'Image here'
    },
    background: String
  },
  data() {
    return {
      isModalOpen: false
    }
  },
  computed: {
    previewStyles() {
      return {
        'padding-bottom': (100 * this.overlayHeight / this.overlayWidth) + '%',
        'background-color': this.background ? this.background : '#ddd'
      }
    },
    previewImageStyles() {
      return {
        top: (100 * this.imageOffsetTop) / this.overlayHeight + '%',
        left: (100 * this.imageOffsetLeft) / this.overlayWidth + '%',
        width: (100 * this.imageWidth) / this.overlayWidth + '%',
        height: (100 * this.imageHeight) / this.overlayHeight + '%'
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.preview {
  text-align: center;
  background-color: #ddd;
  background-repeat: no-repeat;
  background-size: 100% auto;
  position: relative;
  height: 0;

  &.no-image {
    // filter: grayscale(100%);
    span {
      border: 2px solid #eb3323;
      background-color: #ddd;
      box-sizing: border-box;
      font-size: 10px;
      position: absolute;
      width: 100%;
      z-index: 2;

      &::before {
        content: '';
        display: inline-block;
        height: 100%;
        vertical-align: middle;
      }
    }
  }

  .preview-image {
    position: absolute;
  }

  .overlay-image {
    position: relative;
    z-index: 3;
  }

  img {
    display: block;
    width: 100%;
  }
}
</style>
